import { __extends } from "tslib";
import LanguageDetectorNames from "../constants/LanguageDetectorNames";
import AbstractDetector from "./AbstractDetector";
var QueryStringDetector = /** @class */ (function (_super) {
    __extends(QueryStringDetector, _super);
    function QueryStringDetector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The language parameters to look for.
         */
        _this.parameters = ["lang", "language", "locale", "user_language", "culture", "language-code", "skd-language-code"];
        return _this;
    }
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    QueryStringDetector.prototype.detect = function () {
        var language = this.getParameterValue();
        return _super.prototype.detect.call(this, language);
    };
    QueryStringDetector.prototype.getName = function () {
        return LanguageDetectorNames.QueryString;
    };
    /**
     * Iterate the parameters and generate a new array with query parameter values.
     *
     * @returns {(string|null)} The language or null if it could not be found.
     */
    QueryStringDetector.prototype.getParameterValue = function () {
        var search = window.location.search.toLowerCase();
        var value = this.parameters.find(function (parameter) { return !!new URLSearchParams(search).get(parameter); });
        return new URLSearchParams(search).get(value);
    };
    return QueryStringDetector;
}(AbstractDetector));
export default QueryStringDetector;
//# sourceMappingURL=QueryStringDetector.js.map